/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback } from 'react';
import { Cell } from 'styled-css-grid';
import { useDispatch } from 'react-redux';

import Form, { xcriticalFormReset } from '@xcritical/forms';

import { ActionsButtons } from '@crm-framework/actions-buttons';

import { formWireSaveRequestAction } from '../actions';
import { FORM_NAME } from '../consts';

export const WithdrawalForm: React.FC<{ name: string }> = ({
  name,
  children,
}) => {
  const dispatch = useDispatch();

  const resetForm = useCallback(() => {
    dispatch(xcriticalFormReset(FORM_NAME));
  }, []);

  const formSubmit = useCallback(() => {
    dispatch(formWireSaveRequestAction());
  }, []);

  return (
    <Form name={FORM_NAME}>
      <h1>{name} Form</h1>
      {children}
      <Cell width={2}>
        <ActionsButtons
          buttons={[
            {
              title: 'Reset',
              onClick: resetForm,
            },
            {
              title: 'Request',
              appearance: 'primary',
              onClick: formSubmit,
            },
          ]}
        />
      </Cell>
    </Form>
  );
};
